import React from 'react';

import { Grid } from '@material-ui/core';
import FilterListWrapper from 'core/FiltersDialog/components/FiltersListWrapper';
import { get } from 'lodash';
import { useUserPagination } from 'ui-model';

import FiltersContentLoader from 'components/FixedFilters/FiltersContentLoader';
import { Chip, ChipLoader, InfiniteScroll } from 'components/v2';

import { useDialogContext, useFiltersContext } from '../../FiltersDialogContext';
import FilterEmptyState from '../FilterEmptySate';

interface FilterUserListProps {
  name: string;
  type: string;
}

const FilterUserList: React.FC<FilterUserListProps> = ({ name, type = 'user' }) => {
  const { filters, updater, filtersQueryParams } = useFiltersContext();
  const { toggleLockFilters } = useDialogContext();

  const groups = filtersQueryParams && filtersQueryParams.user ? filtersQueryParams.user.groups : null;

  const { isLoading, hasNextPage, fetchNextPage, data: usersInfiniteData } = useUserPagination({
    name,
    groups,
    _sort: 'name:asc',
    postFix: 'all-active-and-invited',
  });

  const usersDataPages = usersInfiniteData?.pages ?? [[]];
  const users = usersDataPages.reduce((ac, user) => ac.concat(user), []);

  const handleSelectItem = (item: any) => {
    updater(type)(item._id);
    toggleLockFilters(false);
  };

  const isSelected = (id: string) =>
    (filters[type].includes('all') && !filters[type].includes(id)) ||
    (filters[type].includes('all') && filters[type].lenth === 1) ||
    (!filters[type].includes('all') && filters[type].includes(id));

  return (
    <FilterListWrapper>
      <InfiniteScroll hasNext={!!hasNextPage} isLoadingNext={isLoading} loadNext={() => fetchNextPage()}>
        <Grid container spacing={8}>
          {get(users, 'length', 0) === 0 ? (
            <FilterEmptyState />
          ) : (
            users &&
            users.map((user) => (
              <Grid item key={user._id}>
                <Chip
                  color="supportPowder"
                  onClick={() => handleSelectItem(user)}
                  label={user.name}
                  selected={isSelected(user._id)}
                />
              </Grid>
            ))
          )}
        </Grid>
      </InfiniteScroll>
      {isLoading && <ChipLoader />}
    </FilterListWrapper>
  );
};

export default (props: any) => (
  <React.Suspense fallback={<FiltersContentLoader />}>
    <FilterUserList {...props} />
  </React.Suspense>
);
